import React, { useEffect, useRef } from 'react'
import jwt_decode from "jwt-decode";
import { ButtonPrevNext, RenderDayCell, RenderEventsStd } from './CalendarUI';
import moment from 'moment';
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";

var AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];

export default function CalendarMonth({
    title,
    data,
    start_date,
    setStartDate,
    end_date,
    setStartEnd,
    ReloadData
}) {

    const calendarRef = useRef(null);

    useEffect(() => {
        if (calendarRef.current) {
            const calendarApi = calendarRef.current.getApi();
            calendarApi.gotoDate(start_date);
        }
    }, [start_date]);

    const handlerPrevNextMonth = (type) => {
        const currentDate = moment(start_date);
        let newDate;

        if (type === 1) {
            // Previous month
            newDate = currentDate.subtract(1, "month");
        } else if (type === 2) {
            // Next month
            newDate = currentDate.add(1, "month");
        }

        if (newDate) {
            const newStartDate = newDate.startOf("month").format("YYYY-MM-DD");
            const newEndDate = newDate
                .endOf("month")
                .add(7, "days")
                .format("YYYY-MM-DD");
            setStartDate(newStartDate);
            setStartEnd(newEndDate);

            console.log("New start_date:", newStartDate);
            console.log("New end_date:", newEndDate);
        }
    };


    return (
        <div>
            <div
                className="d-flex align-items-center justify-content-between py-5 px-8"
                style={{ marginBottom: "-18px", position: "relative" }}
            >
                <div className={`d-flex align-items-center justify-content-between w-100`}>
                    {title && <h4 className="font-weight-bold mb-0 me-3">{title}</h4>}
                    <ButtonPrevNext
                        handlerPrevNextMonth={handlerPrevNextMonth}
                        selected_date={start_date}
                    />
                </div>

            </div>

            <FullCalendar
                ref={calendarRef}
                plugins={[dayGridPlugin]}
                initialView="dayGridMonth"
                dayCellContent={RenderDayCell}
                headerToolbar={{ start: "", center: "", end: "" }}
                fixedWeekCount={false}
                validRange={calculateValidRange(start_date)}
                initialDate={start_date}
                events={data}
                aspectRatio={1.35}
                contentHeight="auto"
                eventContent={(info) => RenderEventsStd(info)}
                eventColor="#000"
                eventTextColor="yellow"
                eventDidMount={(info) => {
                    if (info.event.extendedProps.background) {
                        info.el.style.background = info.event.extendedProps.background;
                    }
                    if (info.event.extendedProps.border) {
                        info.el.style.borderColor = info.event.extendedProps.border;
                    }
                }}
            />
        </div>
    )
}

const calculateValidRange = (start_date) => {
    const startOfMonth = moment(start_date).startOf("month");
    // const endOfMonth = moment(start_date).endOf('month');

    const validStart = startOfMonth.day(0);

    // const validEnd = endOfMonth.day(6);

    return {
        start: validStart.format("YYYY-MM-DD"),
        // end: validEnd.format('YYYY-MM-DD')
        end: "",
    };
};